<ng-template #overlay>
    <div class="modalcontent state1" [ngClass]="(isMobile$ | async) ? 'mobile' : 'desktop'" [class.hide]="state2$ | async">
        <h4 [innerHTML]="'dacookieconsent.State1Headline' | translate"></h4>
        <p [innerHTML]="'dacookieconsent.State1Copy' | translate"></p>
        <div class="modal-actions" [class.hide]="state2$ | async">
            <a
                da-link
                (click)="showCookieSettings()"
                class="settings"
                [innerHTML]="'dacookieconsent.CookieSettingsLinkLabel' | translate"
            ></a>
            <a
                da-button
                class="button primary"
                (click)="acceptAll()"
                themeType="Primary"
                [innerHTML]="'dacookieconsent.AcceptAllButton' | translate"
            ></a>
        </div>
    </div>
    <div class="state2" *ngIf="!(state1$ | async)" [ngClass]="(isMobile$ | async) ? 'mobile' : 'desktop'">
        <div class="modalcontent">
            <h4 *ngIf="isMobile$ | async" [innerHTML]="'dacookieconsent.State1Headline' | translate"></h4>
            <p *ngIf="isMobile$ | async" [innerHTML]="'dacookieconsent.State1Copy' | translate"></p>
            <div class="cookie-groups" id="cookie-groups">
                <h5 [innerHTML]="'dacookieconsent.State2Headline' | translate"></h5>
                <p [innerHTML]="'dacookieconsent.State2Copy' | translate"></p>
                <ng-container *ngIf="cookieConsentForm$ | async as cookieConsentForm">
                    <form [formGroup]="cookieConsentForm" id="cookie-consent-form" class="custom-form">
                        <fieldset>
                            <ng-container *ngFor="let group of formFields">
                                <div>
                                    <ng-container
                                        *ngFor="let control of group.fields"
                                        daDynamicField
                                        [control]="control"
                                        [reactiveFormData]="cookieConsentForm"
                                        [formId]="'cookie-consent-form'"
                                    >
                                    </ng-container>
                                </div>
                            </ng-container>
                        </fieldset>
                    </form>
                </ng-container>
            </div>
        </div>
        <div class="modal-actions">
            <a
                da-button
                class="button secondary"
                (click)="saveCookieSettings()"
                themeType="Secondary"
                [innerHTML]="'dacookieconsent.State2SaveButton' | translate"
            ></a>
            <a
                da-button
                class="button primary"
                (click)="acceptAll()"
                themeType="Primary"
                [innerHTML]="'dacookieconsent.AcceptAllButton' | translate"
            ></a>
        </div>
    </div>
</ng-template>
